import { Box, Button, Flex, Form } from 'dash-ui';

import {
  SaleTeamSelect,
  ContactUrlInput,
  CommissionInput,
  SaleDirectorSelect,
  SaleAssociateSelect,
} from './components/';
import { ISaleTeamItemProps } from './SaleTeamItem.interfaces';

function SaleTeamItem({
  saleTeamIndex,
  saleTeamsList,
  onDeleteSaleTeamClick,
}: ISaleTeamItemProps) {
  return (
    <Flex w="100%" mt={4}>
      <Box flex={1}>
        <Form.Group w="100%" mt={4}>
          <Flex>
            <SaleTeamSelect
              saleTeamsList={saleTeamsList}
              saleTeamIndex={saleTeamIndex}
            />
            <SaleDirectorSelect saleTeamIndex={saleTeamIndex} />
            <SaleAssociateSelect saleTeamIndex={saleTeamIndex} />
          </Flex>
        </Form.Group>
        <Form.Group w="100%" mt={4}>
          <Flex flex={1}>
            <CommissionInput saleTeamIndex={saleTeamIndex} />
            <ContactUrlInput saleTeamIndex={saleTeamIndex} />
            <Flex flex={1} />
          </Flex>
        </Form.Group>
      </Box>
      {saleTeamIndex !== 0 && (
        <Button
          square
          icon="fillTrash"
          variation="flat"
          mt={7.5}
          ml={2}
          iconProps={{ size: 24 }}
          colorVariation="danger"
          onClick={() => onDeleteSaleTeamClick(saleTeamIndex)}
        />
      )}
    </Flex>
  );
}

export default SaleTeamItem;
